module.exports = __webpack_public_path__ + "static/img/14000146.77cfa12b.png";